module.exports = __webpack_public_path__ + "static/media/Years_Delta.2fa90d8e.png";